// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import LinksState from "@store/Framework/Store/Store/Links/LinksState";
import { Draft } from "immer";

const initialState: LinksState = {
    uniqueIdsByPageType: {},
};

const actions = {
    "Store/Links/SetUniqueIdForPageType": (draft: Draft<LinksState>, action: { pageType: string }) => {
        if (!action.pageType) {
            return;
        }

        draft.uniqueIdsByPageType[action.pageType] = Date.now().toString();
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type LinksActions = Parameters<typeof reducer>[1];
export default reducer;
